import Global_var from '../utils/Global_var'

import axios from 'axios';

const GET = {
	GET_RACE: async function (staticRacesJson) {
		
		return (axios({
			method: 'post',
			url: Global_var.live_server + '/api/staticRaces',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			},
			data: staticRacesJson
		}).then(function (res) {			
			return res;
		}))
	},
}

export default GET;